import React from 'react';

import SearchResult from './SearchResult';

export default function ResultsGroup({ setModalOpen, title, searchResults }) {
  return (
    <>
      <div className="text-xs font-semibold text-slate-400 dark:text-slate-500 uppercase px-2 mb-2">
        {title}
      </div>
      <ul className="text-sm mb-4 last:mb-0">
        {searchResults.map((result) => {
          return (
            <SearchResult
              key={result.id}
              setModalOpen={setModalOpen}
              result={result}
              type={title}
            />
          );
        })}
      </ul>
    </>
  );
}
